import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationEN from 'locales/en/translation.json';
import translationLT from 'locales/lt/translation.json';

// 👉 Force default language on first visit
if (!localStorage.getItem('i18nextLng')) {
  localStorage.setItem('i18nextLng', 'lt');
}

const resources = {
  en: { translation: translationEN },
  lt: { translation: translationLT },
};

i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'lt',
    supportedLngs: ['lt', 'en'],
    detection: {
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',
      caches: ['localStorage', 'cookie'],
      checkWhitelist: true,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
